import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex flex-col items-center justify-center gap-1">
    <div className="w-16 h-2 bg-zinc-200 dark:bg-zinc-700 rounded" />
    <div className="w-16 h-2 bg-zinc-200 dark:bg-zinc-700 rounded" />
    <div className="w-8 h-2.5 bg-primary/40 rounded" />
  </div>
);

export default Thumbnail;
